import React, { useCallback } from 'react';
import { useField } from 'formik';
import Autocomplete from '..';

const AutocompleteMemo = React.memo(Autocomplete);

const AutocompleteCFormik = (props) => {
	const { name, onChange, value, onBlur, ...rest } = props;
	const [field, meta, helpers] = useField(name);
	const { setValue, setTouched } = helpers;

	const handleChange = useCallback(
		(_e, nextValue) => {
			setValue(nextValue);
			setTimeout(() => {
				setTouched(true); // Timer for validation issue
				if (onChange) onChange(nextValue);
			}, 0);
		},
		[setValue, setTouched, onChange],
	);

	if (!name) return 'For Autocomplete connected to Formik name is required!';

	return (
		<AutocompleteMemo
			{...rest}
			value={field.value || null}
			onChange={handleChange}
			onBlur={field.onBlur}
			error={(meta.touched || meta.initialTouched) && meta.error}
		/>
	);
};

AutocompleteCFormik.propTypes = {
	...Autocomplete.propTypes,
};

export default AutocompleteCFormik;
